import { css, styled } from 'styled-components'

import { FireCard } from '@nx/fire/card'
import { FireCarousel } from '@nx/fire/carousel'
import { FireImage } from '@nx/fire/image'
import { Heading, Label } from '@nx/fire/typography'

import { LotCard, StyledLotCardSeparator } from '@web/components/common/LotCard'
import { StyledLotCardTitleContainer } from '@web/components/common/LotCard/components/LotCardTitle'

export const StyledLotCard = styled(LotCard)`
  ${StyledLotCardTitleContainer} {
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  ${StyledLotCardSeparator} {
    display: none;
  }
`

export const StyledHeading = styled(Heading)`
  margin: 30px 0;
`

export const StyledFireCarousel = styled(FireCarousel)`
  &:not(:has(+ div)) {
    padding-bottom: 20px;
  }

  & > div {
    align-items: start;

    & > div {
      width: 100%;

      ${({ theme }) => css`
        ${theme.media.up.md} {
          width: 275px;
        }
      `}
    }
  }
`

export const StyledFireCard = styled(FireCard)`
  box-shadow: none;

  & > div {
    padding: 0;
  }
`

export const StyledFireImage = styled(FireImage)`
  object-fit: cover;
`

export const StyledLabel = styled(Label)`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.colours.primary.primary};
    display: flex;
  `}
`
